import TopTabs from '@/features/ui/components/TopTabs'
import { Tab } from '@/features/ui/navigation'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const TabLayout: FC = () => {
    const { t } = useTranslation()

    return (
        <TopTabs>
            <TopTabs.Screen
                name="index"
                options={{
                    tabBarLabel: ({ focused }) => (
                        <Tab active={focused}>{t('settingsTabs.general')}</Tab>
                    ),
                }}
            />
            <TopTabs.Screen
                name="notifications"
                options={{
                    tabBarLabel: ({ focused }) => (
                        <Tab active={focused}>{t('settingsTabs.notifications')}</Tab>
                    ),
                }}
            />
            <TopTabs.Screen
                name="printers"
                options={{
                    tabBarLabel: ({ focused }) => (
                        <Tab active={focused}>{t('settingsTabs.printers')}</Tab>
                    ),
                }}
            />
        </TopTabs>
    )
}

export default TabLayout
